import Swiper from "swiper/bundle"

const progress = document.querySelector(".swiper-slide-info>.progress>span")
const circle = document.querySelector(".swiper-slide-info>.progress>svg:nth-of-type(2) circle")

const mySwiper = new Swiper(".mySwiper", {
    allowTouchMove: false,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    speed: 800,
    autoplay: {
        delay: 5000,
        waitForTransition: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    on: {
        init: () => {
            [document.querySelector(".swiper-button-next"), document.querySelector(".swiper-button-prev")].forEach((elm) => {
                elm.addEventListener("click", () => {
                    circle.style.animation = "none";
                })
            })
        }
    }
});

const singleSwiper = new Swiper(".singleSwiper", {
    slidesPerView: "auto",
    centeredSlides: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1025: {
            centeredSlides: false,
        }
    }
});

mySwiper.on("slideChange", () => {
    progress.innerHTML = ('0' + (mySwiper.activeIndex + 1)).slice(-2)
})

mySwiper.on("sliderMove", () => {
    circle.style.animation = "none";
})